import React from 'react';
import { useEffect } from 'react';

import toast from 'react-hot-toast';
import {
  Route as ReactDOMRoute,
  RouteProps as ReactDOMRouteProps,
  Redirect,
} from 'react-router-dom';

import LoadingContainer from 'components/LoadingContainer';

import { useUserData } from '../hooks/auth';

interface RouteProps extends ReactDOMRouteProps {
  isPrivate?: boolean;
  isLogin?: boolean;
  component: React.ComponentType;
}

const Route: React.FC<RouteProps> = ({
  isPrivate = false,
  isLogin = false,
  component: Component,
  ...rest
}) => {
  const { user, loading, error } = useUserData();

  useEffect(() => {
    if (error) {
      toast.error(
        'Erro ao autenticar na plataforma. Por favor faça o login novamente',
      );
    }
  }, [error]);

  return (
    <>
      {loading ? (
        <LoadingContainer style={{ height: '70vh' }} />
      ) : (
        <ReactDOMRoute
          {...rest}
          render={({ location }) => {
            return (!isPrivate && !isLogin) || (isLogin && !user) ? (
              <Component />
            ) : (
              <Redirect
                to={{
                  pathname: user && isLogin ? '/' : '/signin',
                  state: { from: location },
                }}
              />
            );
          }}
        />
      )}
    </>
  );
};

export default Route;
